import {
  Action,
  AddToCartAction,
  ClearCartAction,
  GetCartModalData,
  RemoveFromCartAction,
  State,
  UpdateCartAction,
  UpdateItemQuantity,
  setLastProductAdded,
} from "./CartContext.types";

const handleUpdateCartReducer = (
  state: State,
  action: UpdateCartAction
): State => {
  return {
    ...state,
    cart: action.payload.cart,
    cartSize: action.payload.cart.cartSize,
    status: "success",
  };
};

const handleAddToCartReducer = (
  state: State,
  action: AddToCartAction
): State => {
  return {
    ...state,
    cart: state.cart,
    cartModalData: state.cartModalData,
    cartItems: [
      ...(state.cartItems ? state.cartItems : []),
      action.payload.item,
    ],
    status: "pending",
  };
};

const handleLastProductAddedReducer = (
  state: State,
  action: setLastProductAdded
): State => {
  return {
    ...state,
    lastProductAdded: action.payload.lastProductAdded,
    status: "pending",
  };
};

const handleRemoveFromCartReducer = (
  state: State,
  action: RemoveFromCartAction
): State => {
  return {
    ...state,
    cartItems: state.cartItems.filter(
      (cartItem) => cartItem.variationId !== action.payload.variationId
    ),
    status: "pending",
  };
};

const handleClearCartReducer = (
  state: State,
  action: ClearCartAction
): State => {
  return {
    ...state,
    cartItems: [],
    status: "pending",
  };
};

const handleUpdateItemQuantityReducer = (
  state: State,
  action: UpdateItemQuantity
): State => {
  return {
    ...state,
    cartItems: state.cartItems.map((cartItem) => {
      if (cartItem.variationId === action.payload.variationId) {
        return {
          ...cartItem,
          quantity: action.payload.quantity,
        };
      }
      return cartItem;
    }),
    status: "pending",
  };
};

const handleGetCartModalDataReducer = (
  state: State,
  action: GetCartModalData
): State => {
  return {
    ...state,
    cartModalData: action.payload.cartModalData,
    status: "success",
  };
};

export const cartReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "ADD_TO_CART":
      return handleAddToCartReducer(state, action);
      break;

    case "UPDATE_CART":
      return handleUpdateCartReducer(state, action);
      break;

    case "UPDATE_ITEM_QUANTITY":
      return handleUpdateItemQuantityReducer(state, action);

    case "REMOVE_FROM_CART":
      return handleRemoveFromCartReducer(state, action);
      break;

    case "GET_CART_MODAL_DATA":
      return handleGetCartModalDataReducer(state, action);
      break;
    case "SET_LAST_PRODUCT":
      return handleLastProductAddedReducer(state, action);
      break;
    case "CLEAR_CART":
      return handleClearCartReducer(state, action);
      break;

    default: {
      // @ts-ignore ignoring because this issue might only happen by incorrectly consuming this context on runtime
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};
